/**
 *
 * @param {string} number
 * @param {number=} precision
 * @returns {string}
 */
export const roundTo = (number, precision = 2) =>
  (Math.round(parseFloat(number || `0.0`) * 100) / 100).toFixed(precision);
